import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AnagraficaLegge,
  FormDataSessionEnum,
  Paginator,
  Sorting,
  SortingDirectionEnum,
} from "@models";
import { AnagraficaService } from "@shared/services/anagrafica.service";
import { UtilsService } from "@shared/services/utils.service";

@Component({
  selector: "app-pages-gestione-anagrafica-ricerca-anagrafica",
  templateUrl: "./ricerca-anagrafica.component.html",
})
export class PagesGestioneAnagraficaRicercaAnagraficaComponent
  implements OnInit
{
  public criteriaForm: FormGroup;
  public paginator: Paginator = new Paginator();
  public tableData: AnagraficaLegge[] = [];
  public tableSort: Sorting[] = [];

  constructor(
    private anagraficaService: AnagraficaService,
    private fb: FormBuilder,
    private utilsService: UtilsService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.tableSort = [{ field: "id", direction: SortingDirectionEnum.DESC }];
    this.criteriaForm = this.fb.group({
      descrizione: this.fb.control(null),
      siglaLegge: this.fb.control(null),
    });
    this.submitForm();
  }

  public modificaLegge(anagraficaLegge: AnagraficaLegge) {
    this.router.navigate(["../modifica", anagraficaLegge], {
      relativeTo: this.route,
    });
  }

  public submitForm() {
    this.anagraficaService
      .search(
        this.criteriaForm.getRawValue(),
        this.paginator.getQueryPaginator(this.tableSort)
      )
      .subscribe((response) => {
        this.tableData = response.content;
        this.paginator.setTotalPage(response.totalElements);
      });
  }

  public onPageChange($event: number) {
    this.paginator.page = $event;
    this.submitForm();
  }

  public resetForm() {
    this.paginator.resetPaginator();
    this.tableData = [];
    this.criteriaForm.reset();
    this.utilsService.setFormDataSession(
      FormDataSessionEnum.ANAGRAFICA_RICERCA,
      this.criteriaForm.getRawValue()
    );
  }
}
